module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-bernd.71dcac35.jpeg";